import TemplateView from '../../../TemplateView'
import {connect} from '../../../redux/utils'
import {isFirstLoading} from '../selectors'
import {bindActionCreators} from 'redux'
import {getLicensesInitialData} from '../actions'
import LicensesPageContent from './LicensesPageContent'
import CompanyInfoPanel from './companyInfoPanel/CompanyInfoPanel'
import LoadingMoire from '../../../LoadingMoire'
import $ from '../../../alias/jquery'
import {showLoadingMoire} from '../loadingMoire/selectors'

class LicensesPage extends TemplateView {
    constructor({
        loadData = () => {},
        loadPurchaseData = () => {},
    }) {
        super()

        this.actions = {
            loadData,
            loadPurchaseData,
        }

        this.state = {
            firstLoading: false,
            showLoadingMoire: false,
        }

        this.onStatePropertyChanged('firstLoading', (firstLoading, prevFirstLoading) => {
            if (firstLoading !== prevFirstLoading && firstLoading === true) {
                this.actions.loadData()
            }
        })

        this.onStatePropertyChanged('showLoadingMoire', (showLoadingMoire) => {
            this.pageLoadingMoire.toggle(showLoadingMoire)
        })
    }

    templateHtml() {
        return '<div class="licensesPageContent">' +
               '    <div class="companyInfoPanelPlaceholder"/>' +
               '    <div class="pageContentPlaceholder"/>' +
               '</div>'
    }

    afterRender() {
        new LicensesPageContent().init(this.find('.pageContentPlaceholder'))
        new CompanyInfoPanel().init(this.find('.companyInfoPanelPlaceholder'))

        this.pageLoadingMoire = new LoadingMoire({
            additionalClass: 'licensesPageLoadingMoire',
            additionalSpinnerSettings: {
                radius: 17,
                length: 13,
                width: 4
            },
            delay: 500,
        }).init($('body'))
    }
}

export default connect(
    (state) => ({
        firstLoading: isFirstLoading(state),
        showLoadingMoire: showLoadingMoire(state),
    }),
    (dispatch) => ({
        loadData: bindActionCreators(getLicensesInitialData, dispatch),
    })
)(LicensesPage)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/LicensesPage.js